import React, { useEffect, useState } from 'react';

import InputStateBlurButton from './InputStateBlurButton';
import './InputStateFixedContainer.scss';

const InputStateFixedContainer = () => {
    const [topOffset, setTopOffset] = useState(0);

    useEffect(() => {
        const isTouch = !window.matchMedia('(pointer: fine)').matches;

        if (isTouch) {
            setPosition();

            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', setPosition);
            }
        }

        return () => {
            if (window.visualViewport && isTouch) {
                window.visualViewport.removeEventListener('resize', setPosition);
            }
        };
    }, []);

    const setPosition = () => {
        if (window.visualViewport) {
            setTopOffset(window.visualViewport.height);
        }
    };

    return (
        <div
            className="input-state-fixed-container"
            style={{ top: `${topOffset}px`, bottom: 'auto', transform: 'translateY(-100%)' }}
            aria-hidden="true"
        >
            <InputStateBlurButton />
        </div>
    );
};

export default InputStateFixedContainer;
